import { useNavigate } from 'react-router-dom';
import styles from './DownloadPage.module.css';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import Logo from '../components/Logo';

const APP_STORE_URL = 'https://apps.apple.com/kr/app/%EB%8B%A4%EC%9E%87/id6779888256';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.daeat.app&pcampaignid=web_share';

const SHOWCASES = [
  {
    tag: '체험단',
    title: '관심 있는 체험단을\n한곳에서',
    desc: '블로그, 인스타, 유튜브 체험단을 한곳에서 모아보고 원하는 공고를 찾아 간편하게 지원해보세요.',
    img: '/campaign.png',
    alt: '체험단 화면',
  },
  {
    tag: '레시피',
    title: '맛있는 레시피를\n함께 나누는 공간',
    desc: '다양한 푸드 크리에이터의 레시피를 둘러보고, 나만의 레시피도 기록하며 함께 공유해보세요.',
    img: '/recipe.png',
    alt: '레시피 화면',
  },
  {
    tag: '피드',
    title: '구독한 크리에이터\n최신 콘텐츠를 피드로',
    desc: '구독한 크리에이터의 새로운 레시피와 소식을 피드에서 확인하고, 관심 있는 콘텐츠를 놓치지 마세요.',
    img: '/feed.png',
    alt: '피드 화면',
  },
];

function AppStoreBadge() {
  return (
    <a href={APP_STORE_URL} className={styles.badge} target="_blank" rel="noopener noreferrer">
      <img src="/Download_on_the_App_Store_Badge_KR_RGB_blk_100317.svg" alt="App Store에서 다운로드" className={styles.badgeImg} />
    </a>
  );
}

function PlayStoreBadge() {
  return (
    <a href={PLAY_STORE_URL} className={styles.badge} target="_blank" rel="noopener noreferrer">
      <img src="/GetItOnGooglePlay_Badge_Web_color_Korean.png" alt="Google Play에서 다운로드" className={styles.badgeImg} />
    </a>
  );
}

function PhoneFrame({ src, alt, className }) {
  return (
    <img src={src} alt={alt} className={`${styles.phoneScreenshot} ${className || ''}`} />
  );
}

export default function DownloadPage() {
  useDocumentMeta({ title: '앱 다운로드', description: '다잇 앱을 설치하고 체험단 소식을 가장 먼저 받아보세요.' });
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      {/* 헤더 */}
      <header className={styles.header}>
        <button className={styles.logo} onClick={() => navigate('/')}>
          <Logo height={22} />
        </button>
        <button className={styles.browseBtn} onClick={() => navigate('/')}>
          체험단 둘러보기
        </button>
      </header>

      {/* 히어로 */}
      <section className={styles.hero}>
        <div className={styles.heroText}>
          <h1 className={styles.heroTitle}>
            푸드 크리에이터를 위한<br />모든 것이 여기에
          </h1>
          <p className={styles.heroSub}>
            원하는 체험단을 찾고, 레시피를 기록하고<br />
            크리에이터들과 연결되는 공간
          </p>
          <div className={styles.badges}>
            <AppStoreBadge />
            <PlayStoreBadge />
          </div>
        </div>
        <div className={styles.heroPhones}>
          <PhoneFrame src="/recipe.png" alt="레시피 화면" className={styles.heroPhoneLeft} />
          <PhoneFrame src="/campaign.png" alt="체험단 화면" className={styles.heroPhoneCenter} />
          <PhoneFrame src="/feed.png" alt="피드 화면" className={styles.heroPhoneRight} />
        </div>
      </section>

      {/* 기능 소개 */}
      <section className={styles.showcases}>
        <div className={styles.showcasesHeader}>
          <h2 className={styles.sectionTitle}>음식의 모든 것을 잇다<br /><span className={styles.sectionTitleAccent}>다잇</span></h2>
        </div>

        {SHOWCASES.map(({ tag, title, desc, img, alt }, i) => (
          <div
            key={tag}
            className={`${styles.showcaseRow} ${i % 2 === 1 ? styles.showcaseRowReverse : ''}`}
          >
            <div className={styles.showcasePhone}>
              <PhoneFrame src={img} alt={alt} />
            </div>
            <div className={styles.showcaseText}>
              <span className={styles.showcaseTag}>{tag}</span>
              <h3 className={styles.showcaseTitle}>
                {title.split('\n').map((line, j) => (
                  <span key={j}>{line}<br /></span>
                ))}
              </h3>
              <p className={styles.showcaseDesc}>{desc}</p>
            </div>
          </div>
        ))}
      </section>

      {/* 하단 CTA */}
      <section className={styles.cta}>
        <div className={styles.ctaInner}>
          <h2 className={styles.ctaTitle}>지금 바로 시작해보세요</h2>
          <p className={styles.ctaSub}>App Store와 Google Play에서 다운로드할 수 있어요</p>
          <div className={styles.badges}>
            <AppStoreBadge />
            <PlayStoreBadge />
          </div>
        </div>
      </section>

      {/* 푸터 */}
      <footer className={styles.footer}>
        <span className={styles.footerLogo}><Logo height={16} /></span>
        <p className={styles.footerCopy}>© 2026 다잇. All rights reserved.</p>
      </footer>
    </div>
  );
}
